<style scoped lang="scss">
.mobile-editor {
  cursor: pointer;
  font-size: 14px;
  margin-left: 5px;
}
.tag-users {
  padding-bottom: 10px;
  line-height: 1.2;
  .icon-user-circle1 {
    margin-right: 10px;
    font-size: 24px;
    color: #ccc;
  }
}
.selected-tags {
  padding-top: 15px;
  margin-bottom: 15px;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  .label {
    margin-bottom: 15px;
  }
  .el-tag {
    margin-right: 10px;
    margin-bottom: 15px;
  }
}
.tag-item {
  cursor: pointer;
  color: #666;
  border-color: #dadadd;
  margin-right: 10px;
  margin-top: 10px;
}
</style>

<template>
  <div>
    <div >
      <el-row :gutter="10" >
        <el-col :md="6" :lg="5">
          <el-input placeholder="手机号" v-model="params.connact_mobile" clearable  size="mini">
            <el-button slot="append" icon="el-icon-search" @click="Search"></el-button>
          </el-input>
        </el-col>
        <el-col :md="6" :lg="5">
          <el-input placeholder="订单号" v-model="params.order_id" clearable  size="mini">
            <el-button slot="append" icon="el-icon-search" @click="Search"></el-button>
          </el-input>
        </el-col>
        <el-col :md="10" :lg="8">
            <el-date-picker v-model="timeRange" type="daterange" start-placeholder="开始时间" ange-separator="至" end-placeholder="结束时间" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" size="mini"></el-date-picker>
        </el-col>
        <el-col :md="6" :lg="8" >
        <el-select  v-model="params.verify" @change="getVerifyChange" clearable  placeholder="审核" size="mini" >
            <el-option
              v-for="item in verifyList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-table :data="dataList"   height="800px" v-loading="loading">
        <el-table-column prop="id"   label="id" width="130"></el-table-column>
        <el-table-column prop="order_id" label="订单号" ></el-table-column>
        <el-table-column prop="realname" label="真实姓名" ></el-table-column>
        <el-table-column prop="connact_mobile" label="联系方式" ></el-table-column>
        <el-table-column prop="symptom" label="症状" ></el-table-column>
        <el-table-column prop="temperature" label="体温" ></el-table-column>
        <el-table-column prop="is_danger" label="14天内是否有境外高危区旅居史" ></el-table-column>
        <el-table-column prop="verify" label="审核状态" >
            <template slot-scope="scope">
                  <span v-if="scope.row.verify==0">未审核</span>
                  <span v-else-if="scope.row.verify==1">已通过</span>
                  <span v-else>未通过</span>
            </template>
        </el-table-column>
        <el-table-column prop="created"  label="时间" >
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">注册时间<br/>{{scope.row.created|datetime('yyyy-MM-dd hh:mm:ss')}}</div>
              <span>{{scope.row.created|datetime('yyyy-MM-dd hh:mm:ss')}}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="380">
          <template slot-scope="scope">
            <el-button type="text" @click="toEdit(scope.row)">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="审核"
        :visible.sync="editDialog"
        width="50%"
        :close-on-click-modal="false"
        :before-close="handleClose">
        <el-form :model="form" >
          <el-form-item label="真实名称" label-width="15%">
            <el-input v-model="form.realname"     autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="身份证号码" label-width="15%">
            <el-input v-model="form.identity"  readonly   autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="症状" label-width="15%">
            <el-input v-model="form.symptom"  readonly   autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="体温" label-width="15%">
            <el-input v-model="form.temperature"  readonly   autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="14天旅居史" label-width="15%">
            <el-input v-model="form.is_danger"  readonly   autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="核酸证明" readonly   label-width="15%" >
            <div class="demo-image__preview">
              <el-image
                style="width: 200px; height: 150px"
                :src="form.image"
                :preview-src-list="[form.image]">
              </el-image>
            </div>
          </el-form-item>

          <el-form-item label="审核" label-width="15%">
            <el-select v-model="form.verify" placeholder="请选择">
              <el-option
                v-for="item in verifyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="未通过原因" v-if="form.verify== 2 " label-width="15%">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="1,上传正确的信息 2,核酸已过期 3,身份信息和姓名不匹配"
              v-model="reason">
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="submit">确 定</el-button>
  </span>
  </el-dialog>
    <div v-if="total_count > params.pageSize" class="content-padded tc">
      <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
      </el-pagination>
    </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {getEpidemicList,getEpidemicUpdate} from '../../../api/auditmember'

export default {
  components: {

  },

  data() {
    return {
      total_count:0,
      loading:false,
      connact_mobile:'',
      realname:'',
      flag:'',
      verify:'',
      reason:'',
      timeRange:'',
      params:
        {
          page: 1,
          pageSize:20,
          connact_mobile:'',
          realname:'',
          flag:'',
          verify:'',
          start_at:'',
          end_at:''
        },
      dataList: [],
      datalogList:[],
      verifyList:[
        {label: '未审核',value: 0},
        {label: '已通过',value: 1},
        {label: '未通过',value: 2}
      ],
      editDialog: false,
      logDialog:false,
      logloading:false,
      url:'',
      srcList:[],
      form:{},
    }
  },
  computed: {
  },

  methods: {
    toEdit(e){
      this.editDialog = true
      this.form=e;
      this.srcList=[e.image];
    },
    handleClose(e){
      this.editDialog=false;
    },
    loghandleClose(e){
      this.logDialog=false;
    },
    dateChange (val) {
      if (val && val.length > 0) {
          this.params.start_at = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
          this.params.end_at = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
          this.params.start_at = ''
          this.params.end_at = ''
      }
      console.log(this.params)
      this.getList(this.params);
    },
    dateStrToTimeStamp (str) {
          return Date.parse(new Date(str))/1000
    },
    submit(){
      var arr={
        id:this.form.id,
        order_id:this.form.order_id,
        verify:this.form.verify,
        reason:this.reason,
      }
      console.log('提交的数组',arr);
      getEpidemicUpdate(arr).then(response => {
          if(response){
            this.$message({
              type: 'success',
              message:'更新成功！'
            })
            this.editDialog=false;
          }else{
            this.$message({
              type: 'error',
              message:'更新失败'
            })
          }
      })
    },
    toLog(row){
      this.logDialog=true;
      this.logloading = true
          let param={
            overseas_drug_id:row.id,
            pageSize:20,
            page:1,
          };
          getAuditmemberLogList(param).then(response => {
            this.datalogList = response.data.data.list
            this.logloading = false
          })
    },
    getParams() {
      if (this.realname) {
        this.params.realname = this.realname
      }
      if (this.connact_mobile) {
        this.params.connact_mobile = this.connact_mobile
      }
      if (this.flag) {
        this.params.flag = this.flag
      }
      if (this.verify) {
        this.params.verify = this.verify
      }
    },
    getList(filter) {
      this.loading = true
      filter.pageSize = 20;
      getEpidemicList(filter).then(response => {
        this.dataList = response.data.data.list
        this.total_count=response.data.data.total_count
        this.loading = false
      })
    },
    Search(){
      this.getParams()
      this.params.page=1;
      this.getList(this.params);
    },
    getFlagChange(e){
      this.params.flag=e;
      this.params.page=1;
      this.getList(this.params);
    },
    getVerifyChange(e){
      this.params.verify=e;
      this.params.page=1;
      this.getList(this.params);
    },
    handleCurrentChange(val){
      this.params.page = val
      this.getParams()
      this.getList(this.params)
    }
  },
  mounted () {

    this.getParams();
    this.getList(this.params)

  }
}
</script>



// WEBPACK FOOTER //
// epidemicControl.vue?781f41ee